<template>
    <div>
        <h3 v-if="title">{{title}}</h3>
        <div class="row">
            <div class="col-12 form-group" v-if="showSearchBox && allowAnonymous && !isProfileDetails">
                <span class="float-right">
                    <person-search :person-search-type="personSearchType"
                                   :showId="showId"
                                   :includeMergedProfiles="false"
                                   @onPersonSelected="onPersonSelected">
                    </person-search>
                </span>
            </div>
            <div class="form-group col-md-12 col-lg-6 col-xl-4">
                <label class="font-weight-bold"
                       :class="personRequiredFields.firstName ? 'required' : ''"
                       :for="'firstName' + _uid">
                    {{$t('person.firstName')}}
                </label>
                <input type="text"
                       class="form-control"
                       v-model="person.firstName"
                       v-validate="personRequiredFields.firstName ? 'required' : ''"
                       :data-vv-as="$t('person.firstName')"
                       :name="'firstName' + _uid"
                       :id="'firstName' + _uid"
                       :readonly="!allowAnonymous || !allowInput || (isProfileDetails && !editing)" />
                <span class="text-danger" v-if="errors.has('firstName' + _uid)">{{ errors.first('firstName' + _uid) }}</span>
            </div>
            <div class="form-group col-md-12 col-lg-6 col-xl-4">
                <label class="font-weight-bold"
                       :class="personRequiredFields.middleName ? 'required' : ''"
                       :for="'middleName' + _uid">{{ $t('person.middleName') }}</label>
                <input type="text"
                       class="form-control"
                       v-model="person.middleName"
                       v-validate="personRequiredFields.middleName ? 'required' : ''"
                       :data-vv-as="$t('person.middleName')"
                       :id="'middleName' + _uid"
                       :name="'middleName' + _uid"
                       :readonly="!allowAnonymous || !allowInput || (isProfileDetails && !editing)" />
                <span class="text-danger" v-if="errors.has('middleName' + _uid)">{{ errors.first('middleName' + _uid) }}</span>
            </div>
            <div class="form-group col-md-12 col-lg-6 col-xl-4">
                <label class="font-weight-bold required"
                       :class="personRequiredFields.lastName ? 'required' : ''"
                       :for="'lastName' + _uid">{{ $t('person.lastName')}}</label>
                <input type="text"
                       class="form-control"
                       v-model="person.lastName"
                       v-validate="personRequiredFields.lastName ? 'required' : ''"
                       :data-vv-as="$t('person.lastName')"
                       :name="'lastName' + _uid"
                       :id="'lastName' + _uid"
                       :readonly="!allowAnonymous || !allowInput || (isProfileDetails && !editing)" />
                <span class="text-danger" v-if="errors.has('lastName' + _uid)">{{ errors.first('lastName' + _uid) }}</span>
            </div>
            <div
                v-if="showEnNames"
                class="form-group col-md-12 col-lg-6 col-xl-4"
            >
                <label class="font-weight-bold"
                       :for="'firstNameEn' + _uid">
                    {{$t('person.firstNameEn')}}
                </label>
                <input type="text"
                       class="form-control"
                       v-model="person.firstNameEn"
                       :name="'firstNameEn' + _uid"
                       :id="'firstNameEn' + _uid"
                       :readonly="!allowAnonymous || !allowInput || (isProfileDetails && !editing)" />
            </div>
            <div
                v-if="showEnNames"
                class="form-group col-md-12 col-lg-6 col-xl-4"
            >
                <label class="font-weight-bold"
                       :for="'middleNameEn' + _uid">
                    {{$t('person.middleNameEn')}}
                </label>
                <input type="text"
                       class="form-control"
                       v-model="person.middleNameEn"
                       :name="'middleNameEn' + _uid"
                       :id="'middleNameEn' + _uid"
                       :readonly="!allowAnonymous || !allowInput || (isProfileDetails && !editing)" />
            </div>
            <div
                v-if="showEnNames"
                class="form-group col-md-12 col-lg-6 col-xl-4"
            >
                <label class="font-weight-bold"
                       :for="'lastNameEn' + _uid">
                    {{$t('person.lastNameEn')}}
                </label>
                <input type="text"
                       class="form-control"
                       v-model="person.lastNameEn"
                       :name="'lastNameEn' + _uid"
                       :id="'lastNameEn' + _uid"
                       :readonly="!allowAnonymous || !allowInput || (isProfileDetails && !editing)" />
            </div>
            <div class="form-group col-md-12 col-lg-8 col-xl-8">
                <label class="font-weight-bold"
                       :class="requiredIdentification ? 'required' : ''"
                >{{ $t('person.identification') }}</label>
                <!-- TODO: Не е променено да позлва required от vuex защото явно някъде се използва изрично без валидация (в лица за контакти примерно...) -->
                <person-identification :identification="person.personIdentification"
                                       :required="requiredIdentification"
                                       :validateUniqueIdNumber="validateUniqueIdNumber"
                                       :validateEgn="validateEgn"
                                       :profile-data="profileData"
                                       :disabled="!allowAnonymous || !allowInput || (isProfileDetails && !editing)"
                                       @getGenderTypeId="person.genderTypeId = $event"></person-identification>
            </div>
            <div class="form-group col-md-12 col-lg-4 col-xl-4">
                <label class="font-weight-bold" :class="personRequiredFields.gender ? 'required' : ''">{{ $t('person.gender') }}</label>
                <dropdown :load-by-parent-sort="true"
                          :parent-sort="nomenclature.GenderType"
                          :required="personRequiredFields.gender"
                          v-model="person.genderTypeId"
                          :fieldName="$t('person.gender')"
                          :height="400"
                          :disabled="!allowAnonymous || !allowInput || (isProfileDetails && !editing)"></dropdown>
            </div>

            <div class="form-group col-md-12 col-lg-6 col-xl-4">
                <label class="font-weight-bold"
                       :class="personRequiredFields.idCardNumber ? 'required' : ''"
                       :for="'idCardNumber' + _uid">{{ $t('person.idCardNumber') }}</label>
                <input type="text"
                       class="form-control"
                       v-model="person.idCardNumber"
                       v-validate="personRequiredFields.idCardNumber ? 'required' : ''"
                       :data-vv-as="$t('person.idCardNumber')"
                       :name="'idCardNumber' + _uid"
                       :id="'idCardNumber' + _uid"
                       :readonly="!allowAnonymous || !allowInput || (isProfileDetails && !editing)" />
                <span class="text-danger" v-if="errors.has('idCardNumber' + _uid)">{{ errors.first('idCardNumber' + _uid) }}</span>
            </div>


            <div class="form-group col-md-12 col-lg-6 col-xl-4">
                <label class="font-weight-bold"
                       :class="personRequiredFields.idCardDateOfIssue ? 'required' : ''"
                       :for="'idCardDateOfIssue' + _uid">{{ $t('person.idCardDateOfIssue') }}</label>
                <date-only-picker v-model="person.idCardDateOfIssue"
                                  :use-utc-time="false"
                                  :enableTimePicker="false"
                                  :convert-to-local-time="true"
                                  :required="personRequiredFields.idCardDateOfIssue"
                                  :readonly="!allowAnonymous || !allowInput || (isProfileDetails && !editing)"
                                  :showTime="false"
                                  :id="'idCardDateOfIssue' + _uid"
                                  :name="'idCardDateOfIssue' + _uid">
                </date-only-picker>
            </div>

            <div class="form-group col-md-12 col-lg-6 col-xl-4">
                <label class="font-weight-bold"
                       :class="personRequiredFields.idCardIssuedBy ? 'required' : ''"
                       :for="'idCardIssuedBy' + _uid">{{ $t('person.idCardIssuedBy') }}</label>
                <input type="text"
                       class="form-control"
                       v-model="person.idCardIssuedBy"
                       v-validate="personRequiredFields.idCardIssuedBy ? 'required' : ''"
                       :data-vv-as="$t('person.idCardIssuedBy')"
                       :name="'idCardIssuedBy' + _uid"
                       :id="'idCardIssuedBy' + _uid"
                       :readonly="!allowAnonymous || !allowInput || (isProfileDetails && !editing)" />
                <span class="text-danger" v-if="errors.has('idCardIssuedBy' + _uid)">{{ errors.first('idCardIssuedBy' + _uid) }}</span>
            </div>

            <div class="form-group col-md-12 col-lg-6 col-xl-4">
                <label class="font-weight-bold required"
                       :class="personRequiredFields.email ? 'required' : ''"
                       :for="'email' + _uid">{{ $t('email') }}</label>
                <input type="text"
                       class="form-control"
                       :readonly="(emailReadonly && person.email) || !allowAnonymous || !allowInput || (isProfileDetails && !editing)"
                       v-model="person.email"
                       v-validate="personRequiredFields.email ? 'required|email' : 'email'"
                       :data-vv-as="$t('email')"
                       :name="'email' + _uid"
                       :id="'email' + _uid" />
                <span class="text-danger" v-if="errors.has('email' + _uid)">{{ errors.first('email' + _uid) }}</span>
            </div>
            <div class="form-group col-md-12 col-lg-6 col-xl-4">
                <label class="font-weight-bold"
                       :class="personRequiredFields.phone ? 'required' : ''"
                       :for="'phone' + _uid" :readonly="!allowAnonymous">
                    {{ $t('person.phone') }}
                </label>
                <input type="text"
                       class="form-control"
                       v-model="person.phone"
                       v-validate="personRequiredFields.phone ? 'required' : ''"
                       :data-vv-as="$t('person.phone')"
                       :id="'phone' + _uid"
                       :name="'phone' + _uid"
                       :readonly="!allowAnonymous || !allowInput || (isProfileDetails && !editing)" />
                <span class="text-danger" v-if="errors.has('phone' + _uid)">{{ errors.first('phone' + _uid) }}</span>
            </div>

            <div class="form-group col-md-12 col-lg-6 col-xl-4">
                <label class="font-weight-bold"
                       :class="personRequiredFields.mobilePhone ? 'required' : ''"
                       :for="'mobilePhone' + _uid">{{ $t('person.mobilePhone') }}</label>
                <input type="text"
                       class="form-control"
                       v-model="person.mobilePhone"
                       v-validate="personRequiredFields.mobilePhone ? 'required' : ''"
                       :data-vv-as="$t('person.mobilePhone')"
                       :id="'mobilePhone' + _uid"
                       :name="'mobilePhone' + _uid"
                       :readonly="!allowAnonymous || !allowInput || (isProfileDetails && !editing)" />
                <span class="text-danger" v-if="errors.has('mobilePhone' + _uid)">{{ errors.first('mobilePhone' + _uid) }}</span>
            </div>

            <div class="form-group col-md-12 col-lg-6 col-xl-4" v-if="showPositionStatistic">
                <label class="font-weight-bold"
                       :class="positionStatIsRequired ? 'required' : ''"
                       :for="'PositionStatistic' + _uid">{{ $t('person.positionStatistic') }}</label>
                <dropdown :load-by-parent-sort="true"
                          :parent-sort="nomenclature.PositionStatistic"
                          :required="positionStatIsRequired"
                          v-model="person.positionStatisticId"
                          :fieldName="$t('person.positionStatistic')"
                          :height="400"
                          :disabled="!allowAnonymous || !allowInput || (isProfileDetails && !editing)"></dropdown>
            </div>

            <div class="form-group col-md-12 col-lg-6 col-xl-4" v-if="showPosition">
                <label class="font-weight-bold"
                       :class="personRequiredFields.position ? 'required' : ''"
                       :for="'position' + _uid">{{ $t('person.position') }}</label>
                <dropdown :load-by-parent-sort="true"
                          :parent-sort="nomenclature.Position"
                          :required="personRequiredFields.position"
                          v-model="person.position"
                          :fieldName="$t('person.position')"
                          :height="400"
                          :disabled="!allowAnonymous || !allowInput || (isProfileDetails && !editing)"></dropdown>
            </div>

            <div class="form-group col-md-12 col-lg-6 col-xl-4" v-if="showPosition">
                <label class="font-weight-bold" :for="'positionStr' + _uid">{{ $t('person.position') }}</label>
                <input type="text"
                       class="form-control"
                       v-model="person.positionStr"
                       :name="'positionStr' + _uid"
                       :id="'positionStr' + _uid"
                       :readonly="!allowAnonymous || !allowInput || (isProfileDetails && !editing)" />
            </div>

            <div class="form-group col-md-12" v-if="showDescription">
                <label class="font-weight-bold" :for="'description' + _uid">{{ $t('person.description') }}</label>
                <textarea rows="3"
                          class="form-control"
                          v-model="person.description"
                          :id="'description' + _uid"
                          :readonly="!allowAnonymous || !allowInput || (isProfileDetails && !editing)"></textarea>
            </div>

            <div class="form-group col-md-12 col-lg-6 col-xl-4" v-if="showExtended">
                <label class="font-weight-bold" :for="'Salutation' + _uid">{{ $t('person.salutation') }}</label>
                <dropdown :load-by-parent-sort="true"
                          :parent-sort="nomenclature.Salutation"
                          v-model="person.salutationId"
                          :fieldName="$t('person.salutation')"
                          :height="400"
                          :disabled="!allowAnonymous || !allowInput || (isProfileDetails && !editing)"></dropdown>
            </div>
            <div class="form-group col-md-12 col-lg-6 col-xl-4" v-if="showExtended">
                <label class="font-weight-bold" :for="'TitleDegree' + _uid">{{ $t('person.titleDegree') }}</label>
                <dropdown :load-by-parent-sort="true"
                          :parent-sort="nomenclature.TitleDegree"
                          v-model="person.titleDegreeId"
                          :fieldName="$t('person.titleDegree')"
                          :height="400"
                          :disabled="!allowAnonymous || !allowInput || (isProfileDetails && !editing)"></dropdown>
            </div>
            <div class="form-group col-md-12 col-lg-6 col-xl-4" v-if="showExtended">
                <label class="font-weight-bold"
                       :class="personRequiredFields.education ? 'required' : ''"
                       :for="'EducationDegree' + _uid">{{ $t('person.educationDegree') }}</label>
                <dropdown :load-by-parent-sort="true"
                          :parent-sort="nomenclature.EducationDegree"
                          :required="personRequiredFields.education"
                          v-model="person.educationDegreeId"
                          :fieldName="$t('person.educationDegree')"
                          :height="400"
                          :disabled="!allowAnonymous || !allowInput || (isProfileDetails && !editing)"></dropdown>
            </div>


            <div class="form-group col-12" v-if="showInstitution">
                <InstitutionSelector v-model="person"
                                     :is-required="personRequiredFields.institution"
                                     :disabled="!allowAnonymous || !allowInput || (isProfileDetails && !editing)">
                </InstitutionSelector>
            </div>

            <div class="form-group col-12" v-if="allowEdit">
                <button v-if="!isProfileDetails" type="button" class="btn btn-primary btn" :class="saving ? 'disabled' : ''" @click.stop="createOrEdit">
                    <i class="fas fa-spinner fa-spin" v-if="saving"></i>
                    <i class="fas fa-save" v-else></i>
                    {{ isNew ? $t('buttons.save.btnText') : $t('buttons.edit.btnText') }}
                </button>
                <div v-else class="btn-group">
                    <button v-if="!editing" type="button" class="btn btn-primary btn" @click.stop="openForEdit">
                        <i class="fas fa-edit"></i>
                        {{ $t('buttons.edit.btnText') }}
                    </button>
                    <button v-if="editing" type="button" class="btn btn-primary btn" :class="saving ? 'disabled' : ''" @click.stop="createOrEdit">
                        <i class="fas fa-spinner fa-spin" v-if="saving"></i>
                        <i class="fas fa-save" v-else></i>
                        {{ $t('buttons.save.btnText') }}
                    </button>
                    <button v-if="editing" type="button" class="btn btn-danger btn" :class="saving ? 'disabled' : ''" @click.stop="cancleEdit">
                        <i class="fas fa-ban"></i>
                        {{ $t('buttons.cancel') }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Person } from '@/models/models';
    import PersonIdentificationComponent from '../person/PersonIdentification';
    import Dropdown from '../dropdown/NomenclatureDropdown';
    import PersonSearch from '../common/PersonSearch';
    import InstitutionSelector from '../common/InstitutionSelector';
    import DateOnlyPicker from '../datepicker/DateOnlyPicker';
    import { NomenclatureParentBySort, PersonSearchType } from '@/models/enums';
    import { mapGetters } from "vuex";

    export default {
        inject: ['$validator'],
        props: {
            person: [Person, Object],
            showCurrent: {
                type: Boolean,
                default: false
            },
            showDescription: {
                type: Boolean,
                default: false
            },
            showSearchBox: {
                Boolean,
                default: true
            },
            title: String,
            requiredIdentification: {
                default: true,
                type: Boolean
            },
            allowEdit: {
                default: false,
                type: Boolean
            },
            emailReadonly: {
                default: false,
                type: Boolean
            },
            allowAnonymous: {
                type: Boolean,
                default: true
            },
            allowInput: {
                type: Boolean,
                default: true
            },
            personSearchType: {
                type: [Number, String],
                default: PersonSearchType.Person
            },
            isProfileDetails: {
                type: Boolean,
                default: false
            },
            personId: {
                type: String,
                required: false,
                default: null
            },
            validateUniqueIdNumber: {
                type: Boolean,
                default: true
            },
            validateEgn: {
                type: Boolean,
                default: false
            },
            showExtended: {
                type: Boolean,
                default: false
            },
            showId: {
                type: Boolean,
                default: false
            },
            showPosition: {
                type: Boolean,
                default: true
            },
            showPositionStatistic: {
                type: Boolean,
                default: true
            },
            showInstitution: {
                type: Boolean,
                default: true
            },
            positionStatIsRequired: {
                type: Boolean,
                default: false
            },
            showEnNames: {
                type: Boolean,
                default: false
            },
            profileData: {
                type: Object,
                default() {
                    return null;
                }
            }
        },
        components: {
            Dropdown,
            'person-identification': PersonIdentificationComponent,
            PersonSearch,
            DateOnlyPicker,
            InstitutionSelector
        },
        data() {
            return {
                nomenclature: NomenclatureParentBySort,
                personSearchBoxId: '',
                saving: false,
                editing: false,
                oldValues: new Person()
                /* personSearchType: PersonSearchType */
            };
        },
        created() {
            if (!this.person) {
                this.person = new Person();
            }
        },
        mounted() {
            if (this.showCurrent || !this.allowAnonymous) {
                this.getCurrentPersonData();
            } else {
                if (!this.isNew) {
                    this.personSearchBoxId = this.person.id;
                }
            }
        },
        methods: {
            onPersonSelected(personSearchModel) {
                this.personSearchBoxId = personSearchModel.id;
            },
            getCurrentPersonData() {
                this.$http
                    .get(`/api/Person/Authenticated`)
                    .then(result => {
                        this.populatePerson(result.data);
                    })
                    .catch(error => {
                        this.$vs.notify({
                            title: this.$t(
                                'request.response.status.' +
                                this.$helpers.errorStatusCode(error)
                            ),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        });
                    });
            },
            getPersonData(id) {
                // TODO: Loading
                this.$http
                    .get(`/api/Person/GetById/${id}`)
                    .then(result => {
                        this.populatePerson(result.data);
                    })
                    .catch(error => {
                        this.$vs.notify({
                            title: this.$t(
                                'request.response.status.' +
                                this.$helpers.errorStatusCode(error)
                            ),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        });
                    });
            },
            populatePerson(p) {
                console.log(p);
                this.person.id = p.id;
                this.person.firstName = p.firstName;
                this.person.middleName = p.middleName;
                this.person.lastName = p.lastName;
                this.person.firstNameEn = p.firstNameEn;
                this.person.middleNameEn = p.middleNameEn;
                this.person.lastNameEn = p.lastNameEn;
                // TODO: Защо от service не идва PersonIdentificationModel а нещо друго?
                // this.person.personIdentification = new PersonIdentification(p.personIdentification)
                if (p.personIdentification) {
                    this.person.personIdentification.identificationTypeId =
                        p.personIdentification.identificationTypeId;
                    this.person.personIdentification.number =
                        p.personIdentification.number;
                    this.person.personIdentification.id = p.personIdentification.id;
                } else {
                    this.person.personIdentification.identificationTypeId = '';
                    this.person.personIdentification.number = '';
                    this.person.personIdentification.id = '';
                }
                this.person.genderTypeId = p.genderTypeId;
                this.person.phone = p.phone;
                this.person.mobilePhone = p.mobilePhone;
                this.person.email = p.email;
                this.person.positionId = p.positionId;
                this.person.position = p.position;
                this.person.description = p.description;
                this.person.userId = p.userId;
                this.person.idCardNumber = p.idCardNumber;
                this.person.idCardDateOfIssue = p.idCardDateOfIssue;
                this.person.idCardIssuedBy = p.idCardIssuedBy;
                this.person.positionStr = p.positionStr;
                this.person.positionStatisticId = p.positionStatisticId;
                this.person.salutationId = p.salutationId;
                this.person.educationDegreeId = p.educationDegreeId;
                this.person.titleDegreeId = p.titleDegreeId;
                this.person.institutionRegisterId = p.institutionRegisterId;
                this.person.relatedUsername = p.relatedUsername;
                this.person.relatedUserEmail = p.relatedUserEmail;

                this.person.specifyInstitution = p.specifyInstitution;
                this.person.institutionOther = p.institutionOther;
                this.person.institutionOtherCountryId = p.institutionOtherCountryId;
                this.person.institutionOtherCityId = p.institutionOtherCityId;
                this.person.institutionOtherCity = p.institutionOtherCity;

                this.$emit('personPopulated', p)
            },
            createOrEdit() {
                this.$validator.validate().then(result => {
                    if (result) {
                        this.saving = true;

                        if (this.isNew) {
                            this.$http
                                .post('/api/Person/create', this.person)
                                .then(response => {
                                    this.$vs.notify({
                                        title: response.request
                                            ? this.$t(
                                                'request.response.status.' +
                                                response.request.status
                                            )
                                            : this.$t(
                                                'request.response.status.200'
                                            ),
                                        text: response.data.message
                                            ? response.data.message
                                            : response.request.statusText
                                                ? response.request.statusText
                                                : response.message,
                                        color: 'success',
                                        time: this.$store.getters
                                            .notificationDuration
                                    });

                                    this.saving = false;
                                    this.cancleEdit();
                                })
                                .catch(error => {
                                    this.$vs.notify({
                                        title: this.$t(
                                            'request.response.status.' +
                                            this.$helpers.errorStatusCode(error)
                                        ),
                                        text: this.$helpers.errorText(error),
                                        color: 'danger',
                                        time: this.$store.getters
                                            .notificationDuration
                                    });

                                    this.saving = false;
                                });
                        } else {
                            this.$http
                                .put('/api/Person', this.person)
                                .then(response => {
                                    this.$vs.notify({
                                        title: response.request
                                            ? this.$t(
                                                'request.response.status.' +
                                                response.request.status
                                            )
                                            : this.$t(
                                                'request.response.status.200'
                                            ),
                                        text: response.data.message
                                            ? response.data.message
                                            : response.request.statusText
                                                ? response.request.statusText
                                                : response.message,
                                        color: 'success',
                                        time: this.$store.getters
                                            .notificationDuration
                                    });

                                    this.saving = false;
                                    this.cancleEdit();
                                })
                                .catch(error => {
                                    this.$vs.notify({
                                        title: this.$t(
                                            'request.response.status.' +
                                            this.$helpers.errorStatusCode(error)
                                        ),
                                        text: this.$helpers.errorText(error),
                                        color: 'danger',
                                        time: this.$store.getters
                                            .notificationDuration
                                    });

                                    this.saving = false;
                                });
                        }
                    }
                });
            },
            openForEdit() {
                this.editing = true;
                this.oldValue = this.person;
            },
            cancleEdit() {
                this.editing = false;
                this.populatePerson(this.oldValue);
            },
            fillProfileData(data) {
                if (!data) {
                    return;
                }

                console.log(data);
            }
        },
        watch: {
            personSearchBoxId(newVal, oldVal) {
                this.getPersonData(newVal);
            },
            profileData: {
                handler: function (newVal, oldVal) {
                    this.fillProfileData(newVal);
                },
                deep: true,
                immediate: true,
            },
        },
        computed: {
            ...mapGetters(['personRequiredFields']),
            isNew() {
                return !this.person || this.person.id <= 0;
            }
        }
    };
</script>

<style scoped>
</style>
